import React, { useEffect, useState } from "react";

interface IProps {
  progress: number;
  photoCount?: number;
}

const UploadProgress: React.FC<IProps> = ({ progress, photoCount = 0 }) => {
  const isProcessing = progress >= 100;
  const [processingSeconds, setProcessingSeconds] = useState(0);

  useEffect(() => {
    if (!isProcessing) {
      setProcessingSeconds(0);
      return;
    }
    const timer = setInterval(() => setProcessingSeconds((s) => s + 1), 1000);
    return () => clearInterval(timer);
  }, [isProcessing]);

  const title = isProcessing
    ? photoCount > 0
      ? `Traitement ${photoCount > 1 ? `des ${photoCount} photos` : "de la photo"} en cours…`
      : "Enregistrement de la demande en cours…"
    : photoCount > 0
    ? `Envoi ${photoCount > 1 ? `des ${photoCount} photos` : "de la photo"} : ${progress}%`
    : "Envoi de la demande en cours…";

  return (
    <div className="w-full px-6 py-3" role="status" aria-live="polite">
      <div className="font-bold text-gray-700 mb-1">{title}</div>
      <div
        className="w-full bg-gray-300 rounded-full h-4 overflow-hidden"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={progress}
      >
        <div
          className={`h-4 rounded-full transition-all duration-300 ${
            isProcessing ? "animate-pulse" : ""
          }`}
          style={{ width: `${Math.max(progress, 2)}%`, backgroundColor: "#4565f6" }}
        />
      </div>
      <div className="text-sm text-gray-500 mt-1">
        {isProcessing
          ? `Le dossier est bien reçu, finalisation en cours (${processingSeconds} s). Merci de ne pas fermer cette page.`
          : "Merci de ne pas fermer cette page pendant l'envoi."}
      </div>
    </div>
  );
};

export default UploadProgress;
